import { alpha, Box, BoxProps, styled } from '@mui/material';

export const StyledSignalsTooltipBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isError'
})<BoxProps & { isError?: boolean }>(({ theme, isError = false }) => ({
  boxSizing: 'border-box',
  padding: theme.spacing(3, 4, 2, 4),
  position: 'relative',

  ...(isError
    ? {
        backgroundColor: alpha(theme.palette.error.main, 0.06),
        color: theme.palette.error.main,
        margin: theme.spacing(-3, -4, 0, -4),
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
      }
    : {
        backgroundColor: alpha(theme.palette.warning.main, 0.06),
        margin: theme.spacing(1, -4, -3, -4),
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius
      })
}));
